<template>
  <transition name="fade-view">
    <div
      v-if="view"
      class="dialog-wrapper alert"
      :class="{ confirm: type === 'confirm', warning: red }"
    >
      <!-- <use-focus-trap v-if="isFocusTrapActive" :options="{ immediate: true }"> -->
      <div class="dialog-box">
        <span class="btn-close" @click="doClose">닫기</span>
        <div v-if="false" class="dialog-header">
          <slot name="header">{{ title }}</slot>
        </div>
        <div class="dialog-body">
          <div class="dialog-body-icon" />
          <span class="dialog-body-text" v-html="message" />
        </div>
        <div class="dialog-footer">
          <button
            v-if="type == 'confirm'"
            type="button"
            class="btn medium primary outline"
            @click="doReject"
          >
            {{ rejectText }}
          </button>
          <button
            v-if="type == 'alert'"
            type="button"
            class="btn medium primary"
            @click="doResolve"
          >
            {{ resolveText }}
          </button>
          <button
            v-if="type == 'confirm'"
            type="button"
            class="btn medium primary"
            @click="doResolve"
          >
            {{ resolveText }}
          </button>
        </div>
      </div>
      <!-- </use-focus-trap> -->
    </div>
  </transition>
</template>

<script>
// import { UseFocusTrap } from '@vueuse/integrations/useFocusTrap/component'

export default {
  components: {
    // UseFocusTrap
  },
  data() {
    return {
      type: 'alert',
      view: false,
      title: '알림',
      message: '내용',
      resolveText: 'Thực hiện',
      rejectText: 'Quay lại',
      resolve: null,
      reject: null,
      // sytv
      red: false,
      isFocusTrapActive: false
    }
  },
  watch: {
    view() {
      if (this.view) {
        this.isFocusTrapActive = true
      }
    }
  },
  methods: {
    doResolve() {
      this.resolve && this.resolve()
      this.CloseDialog()
    },
    doReject() {
      this.reject && this.reject()
      this.CloseDialog()
    },
    doClose() {
      this.type === 'alert' ? this.doResolve() : this.doReject()
    },
    CloseDialog() {
      this.view = false
      this.isFocusTrapActive = false
    },
    initialFocus() {
      return this.$refs.dialog
    }
  }
}
</script>

<style lang="scss">
.dialog-wrapper {
  .dialog-box {
    animation: vxDialog 0.2s ease-in-out;
  }
}
</style>
